import { useMediaQuery, Box } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { createContext } from 'react';
import AppRouter from '../routers/AppRouter'
import SideBar from './SideBar';
import TopBar from './TopBar';

export const LayoutContext = createContext({
    isMobile: false
});

const UI = () => {

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // мобильный экран


    return (
        <>
            <LayoutContext.Provider value={{ isMobile }}>
                <BrowserRouter>
                    <Box
                        display="flex"
                        flexDirection="row"
                        minHeight="100vh"
                        height="100vh"
                        padding={isMobile ? 0 : 2}
                        gap={2}
                        justifyContent="space-between"
                        alignItems="stretch"
                    >

                       <SideBar isMobile={isMobile} />

                        <Box
                            display="flex"
                            flexDirection="column"
                            flexGrow={2}
                            gap={2}
                            overflow="scroll"
                        >
                            <TopBar isMobile={isMobile} />
                            <AppRouter />
                        </Box>

                    </Box>

                </BrowserRouter>
            </LayoutContext.Provider>
        </>
    );
};

export default UI;